import { get, post, put, fromSubmit, DEVELOPMENT_URL, PRODUCTION_URL } from './http'
// 图片上传路径
export const imageUploadUrl =
  process.env.NODE_ENV === 'development'
    ? DEVELOPMENT_URL + 'base/image/upload'
    : PRODUCTION_URL + 'base/image/upload'

export const imageIpsUploadUrl =
  process.env.NODE_ENV === 'development'
    ? DEVELOPMENT_URL + 'base/image/upload/ipfs'
    : PRODUCTION_URL + 'base/image/upload/ipfs'

// 图片下载
export const imageDownload = (g) => get('/base/image/download', g)
// 获取系统时间
export const getSysTime = (g) => get('/time/currentTime', g)
// 公告查询
export const getNotice = (g) => get('/notice/queryPage', g)
// 公告详情
export const getNoticeDetail = (g) => get('/notice/detail/' + g.id, g)
// 首页公告
export const getNoticeIndex = (g) => get('/notice/index', g)
// 轮播首页列表
export const getBannerList = (g) => get('/banner/index/' + g.clientType, g)
// 轮播详情
export const getBannerDetail = (g) => get('/banner/detail/' + g.uuid, g)
// 邀请
export const getInviteInfo = (g) => get('/userInvite/selfInviteInfo', g)
// 我的邀请分页
export const getInviteList = (g) => get('/userInvite/selfInvitePage', g)
// 填写邀请码/userInvite/invite/{inviteCode}
export const inviteCodeSubmit = (g) => get('/userInvite/invite/' + g.inviteCode, g)

// 注册短信验证码
export const getRegisterSmsCode = (g) => post('/user/getRegisterSmsCode', g)
// 登录短信验证码
export const getSignInSmsCode = (g) => post('/user/getSignInSmsCode', g)
// 忘记密码短信验证码
export const getForgetPasswordSmsCode = (g) => post('/user/getForgetPasswordSmsCode', g)
// 注册
export const register = (p) => post('/user/register', p)
// 密码登录
export const signIn = (p) => post('/user/signIn', p)
// 短信登录/user/signInBySms
export const signInBySms = (p) => post('/user/signInBySms', p)
// 重置密码
export const modifyPasswordByMobile = (p) => post('/user/modifyPasswordByMobile', p)
// 更换手机号，获取旧手机验证码/user/getOldPhoneSmsCode
export const getOldPhoneSmsCode = (g) => get('/user/getOldPhoneSmsCode', g)
// 更换手机号，获取新手机验证码/user/getOldPhoneSmsCode
export const getNewPhoneSmsCode = (g) => get('/user/getNewPhoneSmsCode', g)
// 通过手机号和验证码修改手机号码
export const modifyPhoneByMobileAndSms = (p) => post('/user/modifyPhoneByMobileAndSms', p)

// 查询详情
export const userDetail = (g) => get('/user/detail', g)
// 基本信息设置/user/baseAddOrUpdate
export const baseAddOrUpdate = (p) => post('/user/baseAddOrUpdate', p)
// 实名认证
export const realAuth = (p) => post('/user/realAuth', p)
// 再次实名
export const realAuthAgain = (p) => post('/user/realAuthAgain', p)

// 收款方式设置
export const addOrUpdateCollectionWay = (p) => post('/user/addOrUpdateCollectionWay', p)
// 收货地址提交
export const addOrUpdateAddress = (p) => post('/user/addOrUpdateAddress', p)
// 隐私设置查询
export const getSelectVisible = (g) => get('/user/selectVisible', g)
// 隐私设置/user/visibleSet
export const visibleSet = (p) => post('/user/visibleSet', p)
//  用户实名认证银行卡
export const banKCardRealName = (p) => post('/bankCard/banKCardRealName', p)
// 版权费

// 版权费设置
export const royaltySet = (p) => post('/user/royaltySet', p)

// 市场

// 市场列表
export const marketList = (g) => get('/nft/market/list', g)
// 市场分类
export const categoryList = (g) => get('/baseSet/category/listALl', g)
// NFT详情
export const marketDetail = (g) => get('/nft/market/detailAllStatus/' + g.nftId, g)
// nft详情 带副本
export const marketDetailNum = (g) => get('/nft/market/detail', g)
// nft交易历史
export const nftRecordList = (g) => get('/nftrecord/market/list', g)
// 二级市场藏品分类
export const nftClassification = (g) => get('/samplereels/market/classification', g)
// 二级市场盲盒分类
export const boxClassification = (g) => get('/blindBox/market/classification', g)
// nft分页列表
export const nftNumberList = (g) => get('/nftNumber/market/list', g)
// nft副本详情
export const nftNumberDetail = (g) => get('/nftNumber/market/detail/' + g.numberId, g)
// 二级分页列表历史记录
export const nftRecordSecondList = (g) => get('/nftrecord/market/secondList', g)
// 获取级别名称列表
export const selectLevelName = (g) => get('/nft/market/selectLevelName', g)
// 我的

// 我的NFT列表
export const personalList = (g) => get('/nftNumber/personal/myNft', g)
// 我赠与的NFT列表
export const myPassOnNft = (g) => get('/nftNumber/personal/myPassOnNft', g)
// 创建或者修改NFT
export const personalSubmit = (p) => post('/nft/personal/submit', p)
// 我的NFT详情
export const personalNftInfo = (g) => get('/nft/personal/detail', g)
// 我卖出的NFT
export const mySellOut = (g) => get('/nftNumber/personal/mySellOut', g)
// 我卖出的盲盒
export const mySellOutBox = (g) => get('/boxUser/personal/mySellOutBox', g)
// 交易记录/order/listPerson
export const orderListPerson = (p) => get('order/listPerson', p)
// 我可合成藏品分页列表
export const myNftCanHc = (g) => get('/nftNumber/personal/myNftCanHc', g)

// 订单
export const orderBooking = (p) => post('/order/booking', p)
// 订单详情
export const orderDetail = (p) => get('/order/detailByOrderNo', p)
// 订单地址提交
export const orderAddAddress = (p) => post('/order/addAddress', p)
// 支付渠道获取
export const obtainChannelInfo = (g) => get('/order/obtainChannelInfo', g)
// 银行卡查询
export const cardNoValidate = (g) => get('/order/cardNoValidate', g)
// 取消支付
export const orderCancelPay = (p) => post('/order/cancelPay', p)
// 获取用户实名卡
export const getUserCardList = (g) => get('/userCardReal/getUserCardList', g)
// 默认银行卡设置
export const setUserCardDefault = (p) => post('/userCardReal/setUserCardDefault', p)
// 删除用户实名卡
export const delUserCardReal = (p) => post('/userCardReal/delUserCardReal', p)

// 藏品集
export const samplereelsList = (p) => get('/samplereels/market/list', p)
// 藏品集详情
export const samplereelsDetail = (p) => get('/samplereels/market/detail/' + p.worksId)
// 藏品集下的nft
export const listByWorksId = (p) => get('/nft/market/listByWorksId/', p)
// 个人藏品集
export const samplereelsMyList = (p) => get('/samplereels/personal/MyList', p)
// 藏品集排行榜
export const samplereelsRankList = (p) => get('/samplereels/market/ranking', p)
// /精选藏品集分页列表
export const samplereelsSelectedRank = (p) => get('samplereels/market/selectedRank', p)
// 藏品精品分页列表
export const selectListByWorksId = (p) => get('/samplereels/market/selectListByWorksId', p)
// 他人

// 他人详情
export const detailUser = (p) => get('/user/detailUserOrSys', p)
// 通过电话查询他人信息
export const detailUserInfoByPhone = (p) => get('/user/getUserByPhone', p)

// 他人创造的nft /nft/market/listWithCreate
export const userListCreate = (p) => get('/nftNumber/second/market/otherOwn', p)
// 他人卖出的nft
export const userListSellOut = (p) => get('/nftNumber/second/market/otherSellOut', p)
// 他人藏品集
export const samplereelsOtherList = (p) => get('/samplereels/market/otherList', p)
// 查询他人创建藏品集
export const userModeList = (p) => get('/samplereels/userModeList', p)
// 他人拥有盲盒
export const otherBoxlist = (p) => get('/boxUser/market/otherBoxlist', p)
// 他人转赠盲盒
export const otherPassOnBox = (p) => get('/boxUser/market/otherPassOnBox', p)
// 他人卖出盲盒
export const otherSellOutBox = (p) => get('/boxUser/market/otherSellOutBox', p)

// 转赠验证码获取
export const getPassOnSmsCode = (p) => get('/user/getPassOnSmsCode', p)
// 转赠
export const nftPassOn = (p) => post('/nft/personal/passOn', p)

// 新闻类
// 获取最新的7条新闻
export const findNewsByNewsType = (g) => get('/news/findNewsByNewsType', g)
// 新闻详情
export const newsDetail = (g) => get('/news/detail', g)
// 新闻列表
export const newsPageList = (g) => get('/news/pageList', g)
// 友情链接
export const webMenuList = (g) => get('/webMenu/list', g)

// F码类
// F码分页列表
export const fcodeList = (g) => get('/nft/fcodePage', g)
// F码分页列表条件查询
export const fcodePageList = (g) => get('/fcode/canUsePageList', g)
// 验证F码是否有效
export const checkoutFCode = (g) => get('/nft/checkoutFCode', g)

// 下单是否启用人机验证
export const orderCaptchaValidate = (g) => get('/order/orderCaptchaValidate', g)
export const sandPay = (g) => fromSubmit('https://cashier.sandpay.com.cn/gw/web/order/create', g)

// 盲盒
// 盲盒列表
export const blindBoxList = (g) => get('/blindBox/market/list', g)
// 盲盒详情
export const blindBoxInfo = (g) => get('/blindBox/market/detail/' + g.boxUserId, g)
// 我的盲盒详情
export const myBlindBoxInfo = (g) => get('/boxUser/personal/detailInfo', g)
// 盲盒交易历史/blindBox/market/event
export const blindBoxHistory = (g) => get('/blindBox/market/event', g)
// 拥有盲盒列表
export const myBoxlist = (g) => get('/boxUser/person/myBoxlist', g)
// 转赠的盲盒列表
export const myPassOnBox = (g) => get('/boxUser/personal/myPassOnBox', g)
// 开启盲盒
export const openBox = (p) => post('/boxUser/personal/openBox', p)
// 转赠盲盒
export const boxPassOn = (p) => post('/boxUser/personal/passOn', p)
// 盲盒二级详情
export const secondBoxInfo = (g) => get('/boxUser/second/market/detailInfo', g)
// 盲盒排行
export const boxRankList = (g) => get('/blindBox/market/ranking', g)
//  盲盒精选分页列表
export const boxSelectedRank = (g) => get('/blindBox/market/selectedRank', g)
// 合成
// 合成市场列表
export const synthesisList = (g) => get('/synthesis/task/searchList', g)
// 合成玩法列表
export const synthesisSearchList = (g) => get('/synthesis/searchList', g)
// 合成详情
export const synthesisDetail = (g) => get('/synthesis/person/detail', g)
// 合成
export const composeSubmit = (p) => post('/synthesis/person/synthesis', p)
// 任务详情
export const synthesisTaskDetail = (g) => get('/synthesis/task/detail/' + g.taskId, g)

// 购物卡
// 我的购物卡列表
export const shopCardListWithMe = (p) => post('/usershopcard/shopCardListWithMe', p)
// 购物卡支出列表
export const shopCardPayListWithMe = (p) => post('/usershopcard/shopCardPayListWithMe', p)
// 购物卡充值列表
export const shopCardRechargeListWithMe = (p) => post('/usershopcard/shopCardRechargeListWithMe', p)
// 购物卡收入列表
export const shopCardProfitListWithMe = (p) => post('/usershopcard/shopCardProfitListWithMe', p)
// 购物卡提现明细列表
export const shopCardWithdrawListWithMe = (p) => post('/usershopcard/shopCardWithdrawListWithMe', p)
// 购物卡设置密码
export const setShopCardPassword = (p) => post('/usershopcard/setShopCardPassword', p)
// 购物卡重置密码
export const resetShopCardPassword = (p) => post('/usershopcard/resetShopCardPassword', p)
// 获取购物卡重置密码验证码
export const getResetShopCardPasswordSmsCode = (p) => post('/user/getResetShopCardPasswordSmsCode', p)
// 购物卡提现
export const withdrawApply = (p) => post('/usershopcard/withdrawApply', p)
// 购物卡提现手机验证码
export const getShopCardWithdrawSmsCode = (p) => post('/user/getShopCardWithdrawSmsCode', p)
// 购物卡配置参数获取
export const usershopcardconfig = (p) => post('/usershopcard/configParameter', p)

// 站内信
export const websiteMessage = (g) => get('/websiteMessage', g)
// 站内信详情/websiteMessage/details/{messageId}
export const websiteMessageDetails = (g) => get('/websiteMessage/details/' + g.messageId, g)
// 阅读全部未读消息
export const websiteMessageReadAll = (g) => put('/websiteMessage/read/all', g)
// 未读数量
export const websiteMessageNew = (g) => get('/websiteMessage/new/message/number', g)

// 二级
// 服务费
export const selectServiceCopyright = (g) => get('/nft/market/selectServiceCopyright', g)
// 转售-藏品
export const nftResale = (p) => post('/nft/personal/resale', p)
// 转售-盲盒
export const boxResale = (p) => post('/boxUser/personal/resale', p)
// 取消挂售藏品
export const cancelSale = (p) => post('/nft/personal/cancelSale', p)
// 取消挂售盲盒
export const boxCancelSale = (p) => post('/boxUser/personal/cancelSale', p)
// 盘古市场-藏品
export const secondMarketList = (g) => get('/nftNumber/second/market/list', g)
// 盘古市场-盲盒
export const secondBoxMarketList = (g) => get('/boxUser/second/market/list', g)
// 挂售详情
export const consignmentrecordDetail = (g) => get('/consignmentrecord/detail', g)
// 挂售记录

export const consignmentrecord = (g) => get('/consignmentrecord/personal/myList', g)
// 获取挂售验证码（价格低于一半）
export const getResaleSmsCode = (g) => get('/user/getResaleSmsCode', g)

// DAO
// 创建社区
export const createCommunity = (p) => post('/community/create', p)
// 创建社区
export const updateCommunity = (p) => put('/community/update', p)
// 社区首页
export const communityHome = (p) => get('/community/my/home', p)
// 社区详情
export const communityDetail = (p) => get('/community/details', p)
// 我的社区详情
export const myCommunityDetail = (p) => get('/community/my/details', p)
// 申请备案审核
export const examineApply = (p) => post('/examine/community/apply', p)
// 备案审核列表
export const filingList = (p) => get('/examine/community/page', p)
// nvwa能量列表
export const powerList = (p) => get('/nvwa/energy/log/page', p)
// 社区工具-stone献祭查询
export const stonePledgeQuery = (p) => get('/community/user/query/details', p)
// 社区工具-社区查询
export const communityQuery = (p) => get('/community/search', p)
// 社区成员列表
export const communityUserList = (p) => get('/community/user/page', p)
// 查询社区用户-供移交社区使用
export const transferUserDetail = (p) => get('/community/user/transfer/query/details', p)
// 献祭社区（加入）
export const pledgeCommunity = (p) => post('/community/user/join', p)
// 移交社区
export const transferCommunity = (p) => post('/community/transfer', p)
// 退出社区前的校验
export const outCommunityBeforeCheck = (p) => get('/nvwa/energy/log/calculation', p)
// 退出社区
export const outCommunity = (p) => put('/community/user/leave', p)
// 发送短信验证码(移交社区)
export const sendTransferSmsCode = (p) => get('/community/send/sms/valid/code', p)
// 社区列表
export const communityList = (p) => get('/community/list', p)
// 查询可以献祭的小石头和大石头数量
export const queryStoneNum = (p) => get('/nftNumber/stone/num', p)

// 铸造
// 我创建的藏品集分页列表
export const samplereelsMyCreateList = (p) => get('/samplereels/personal/myCreateList', p)
// 我创建的藏品分页列表
export const nftMyCreateList = (p) => get('/nft/personal/myCreateList', p)
// 作品集/盲盒某个类别分类列表
export const classificationByName = (p) => get('/samplereels/market/classificationByName', p)
// 铸造支出
export const userModePayListWithMe = (p) => post('/usershopcard/userModePayListWithMe', p)
// 铸造退款
export const userModeRefundListWithMe = (p) => post('/usershopcard/userModeRefundListWithMe', p)
// 下载用户铸造模板
export const downLoadExcel = (p) => get('/nft/downLoadExcel', p)
// 导入NFT信息
export const importNftExcel = (p) => post('/nft/importNftExcel', p)
// 上架
export const groundNft = (p) => post('/nft/personal/groundNft', p)
// 新增
export const submitNft = (p) => post('/nft/personal/submit', p)
// 修改
export const submitEdit = (p) => post('/nft/personal/edit', p)
// 审核身份证
export const applyAuth = (p) => post('/samplereels/personal/applyAuth', p)
// 下架
export const offNft = (p) => post('/nft/personal/offNft', p)
// 退款
export const refundNft = (p) => post('/nft/personal/refund', p)

// 添加nft举报
export const addNftReport = (p) => post('/nftReport/addNftReport', p)
// 是否用户铸造
export const userCanCast = (p) => get('/user/userCanCast', p)
// 获取系统参数
export const selectParamsValues = (p) => get('/nft/market/selectParamsValues', p)

// 创建作品集

export const samplereelsNfts = (p) => post('/samplereels/personal/submit', p)

// 自己铸造藏品集详情
export const samplereelsPersonalDetail = (p) => get('/samplereels/personal/detail/' + p.worksId)

// 分页获取燃烧nft数据

export const getBurnNftList = (p) => get('/nvwaBurn/getBurnNftList', p)

// 发起燃烧
export const addBurnNft = (p) => post('/nvwaBurn/addBurnNft', p)

// 分页获取用户燃烧记录
export const getBurnNftRecordList = (p) => get('/nvwaBurn/getBurnNftRecordList', p)
//  获取宝箱基础数据
export const getBuyTreasureData = (p) => get('/nvwaBurn/getBuyTreasureData', p)
// 获取用户购买宝箱数据
export const getBuyTreasureList = (p) => get('/nvwaBurn/getBuyTreasureList', p)

// 获取dao池基础信息

export const getDaoEnergyPool = (p) => get('/nvwaBurn/getDaoEnergyPool', p)
// 获取当前好运池基础数据
export const getLuckyEnergyPool = (p) => get('/nvwaBurn/getLuckyEnergyPool', p)

// 查询以往轮好运池开奖记录

export const getLuckyPoolBeforeRecord = (p) => get('/nvwaBurn/getLuckyPoolBeforeRecord', p)

// 获得接力池基础数据

export const getRelayEnergyPool = (p) => get('/nvwaBurn/getRelayEnergyPool', p)

// 查询接力池以往排名

export const getRelayPoolBeforeRecord = (p) => get('/nvwaBurn/getRelayPoolBeforeRecord', p)

// 查询当前轮接力池排名

export const getRelayPoolRecord = (p) => get('/nvwaBurn/getRelayPoolRecord', p)

// 获取用户本轮幸运数字

export const getUserLuckyNum = (p) => get('/nvwaBurn/getUserLuckyNum', p)
// 分页获取所有用户开奖数据

export const getUserOpenTreasureRecord = (p) => get('/nvwaBurn/getUserOpenTreasureRecord', p)
// 开启宝箱
export const openTreasure = (p) => get('/nvwaBurn/openTreasure', p)
// 获取可以燃烧的藏品集
export const getBurnWorkList = (p) => get('/nvwaBurn/getBurnWorkList', p)



// WEBPACK FOOTER //
// ./src/request/api.js